<template>
    <div class="layout-messages">
        <transition-group
            name="layout-messages"
            tag="div"
            class="layout-messages__wrapper"
            appear
        >
            <v-alert
                v-for="msg in messages"
                :key="msg.id"
                :type="msg.type"
                class="mb-2"
            >
                <div
                    v-if="msg.use_html"
                    v-html="msg.msg"
                ></div>
                <template v-else>{{ msg.msg }}</template>
            </v-alert>
        </transition-group>
    </div>
</template>

<script lang="ts" setup>
import { useMessageStore } from "@/store/message.store";
import { computed } from "vue";

const message_store = useMessageStore();
const messages = computed(() => message_store.messages);
</script>
